import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";

export const CurrentSchoolCountryName = "current-school-address-country";

export function CurrentSchoolCountry({
  label = "Current School Country",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <RenderElement
      control={control}
      element={{
        _id: CurrentSchoolCountryName,
        type: "countryselect",
        name: CurrentSchoolCountryName,
        label: label,
        validate: { presence: true },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}
